/* eslint-disable no-restricted-globals */
import config from "../../config/config";

export default function Logout({ user }) {
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = config.url.login;
  return null;
}
